import React from 'react';
import { Mail, Phone } from 'lucide-react';

const LOGO_URL = '/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Solvere"
                className="h-14 w-auto drop-shadow-[0_0_8px_rgba(59,130,246,0.45)]"
              />
              <span className="text-white font-semibold text-lg">Solvere</span>
            </div>

            <p className="text-slate-400 mb-5 max-w-md leading-relaxed">
              Sistemas a medida para ordenar procesos, reducir errores y mejorar el control del trabajo diario.
            </p>

            <div className="space-y-3">
              <a
                href="mailto:contacto@solvere.com.ar"
                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
              >
                <Mail className="h-4 w-4" />
                contacto@solvere.com.ar
              </a>

              <a
                href="tel:3425376513"
                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
              >
                <Phone className="h-4 w-4" />
                342-5376513
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Soluciones</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Sistemas de gestión
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Talleres y rubros técnicos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Aplicaciones móviles
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Automatización e integraciones
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Empresa</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => scrollToSection('process')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Cómo trabajamos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Casos reales
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Preguntas frecuentes
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-sm text-slate-500">
            © {currentYear} Solvere. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;